export enum FindAllInvoicesSort {
  INVOICE_DATE = 'invoiceDate',
  UPDATED_DATE = 'updatedDate',
  INVOICE_NUMBER = 'invoiceNumber',
}
